var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"top"},[_c('v-img',{attrs:{"src":require("../assets/Cappuccino.jpg"),"gradient":"to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)","height":_vm.height}}),_c('div',{staticClass:"slide font-weight-thin"},[_c('SlideIn',[_c('p',[_vm._v("Better Coffee, Better World.")])])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }